import { List } from 'immutable';

import { entityEffects } from './entity/effects';
import { coreFeatureFlagEffects } from './featureFlag';
import { sessionEffects } from './session/effects';
import { userEffects } from './users';
import { claimsEffects } from "./claims/effects";

export const effects = List([coreFeatureFlagEffects, entityEffects, sessionEffects, userEffects, claimsEffects]);
